import { useState, useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ContactDialog } from "@/components/ContactDialog";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import ResearchPage from "@/pages/ResearchPage";
import PlatformPage from "@/pages/PlatformPage";
import TechnologyPage from "@/pages/TechnologyPage";
import AIPage from "@/pages/AIPage";
import ApplicationsPage from "@/pages/ApplicationsPage";
import TeamPage from "@/pages/TeamPage";
import PartnerPage from "@/pages/PartnerPage";
import NotFoundPage from "@/pages/NotFoundPage";
import AdminContactsPage from "@/pages/AdminContactsPage";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  const [contactOpen, setContactOpen] = useState(false);
  const [prefill, setPrefill] = useState(null);

  const open = useCallback((pre) => {
    setPrefill(pre || null);
    setContactOpen(true);
  }, []);

  const openDossier = useCallback(() => {
    open({
      interest: "research",
      message:
        "I'd like to request the Neurobolt team dossier under NDA. Brief context on my organization and intent: ",
    });
  }, [open]);

  return (
    <div className="App grain">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:px-4 focus:py-2 focus:rounded-full focus:bg-white focus:text-[#020617] focus:font-semibold focus:text-[13px]"
      >
        Skip to content
      </a>
      <BrowserRouter>
        <ScrollToTop />
        <Navbar onOpenContact={() => open()} />
        <div id="main" tabIndex={-1}>
          <Routes>
            <Route
              path="/"
              element={
                <HomePage
                  onOpenContact={() => open()}
                  onRequestDossier={openDossier}
                />
              }
            />
            <Route path="/platform" element={<PlatformPage onOpenContact={() => open()} />} />
            <Route path="/technology" element={<TechnologyPage onOpenContact={() => open()} />} />
            <Route path="/ai" element={<AIPage onOpenContact={() => open()} />} />
            <Route path="/applications" element={<ApplicationsPage onOpenContact={() => open()} />} />
            <Route
              path="/team"
              element={
                <TeamPage
                  onOpenContact={() => open()}
                  onRequestDossier={openDossier}
                />
              }
            />
            <Route path="/research" element={<ResearchPage onOpenContact={() => open()} />} />
            <Route path="/partner" element={<PartnerPage />} />
            <Route path="/contact" element={<PartnerPage />} />
            <Route path="/admin/contacts" element={<AdminContactsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
      <ContactDialog
        open={contactOpen}
        onOpenChange={setContactOpen}
        prefill={prefill}
      />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
